'use client';

// FAQs accordion — clean Stripe-style.
//
// Standard accordion: large readable question text, body-paragraph answer,
// generous py per row. Tracks first-expand per id via a local Set; emits
// SUPPORT_MAINNET_FAQ_OPENED only on the first expansion of each row.
import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';
import { APP_HEADER_SCROLL_MARGIN_CLASS } from '@/components/layout/app-header-sticky-top';
import { parseInlineBold } from '@/components/support-mainnet/disclaimer-block.utils';
import { SectionHeading } from '@/components/support-mainnet/section-heading';
import { AppAccordion } from '@/components/ui/app-accordion';
import { InfoModal } from '@/components/ui/info-modal';
import { DOCS_URL } from '@/config/docs-links';
import { onEvent } from '@/events';
import { FAQ_ITEMS } from '@/lib/support-mainnet/data';
import { READING_COLUMN_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';
const DEFAULT_OPEN_IDS: string[] = [];
export function FaqsAccordion() {
  const $ = _c(22);
  const t = useTranslations("supportMainnet.faqs");
  const tCommon = useTranslations("common");
  const [openIds, setOpenIds] = useState(DEFAULT_OPEN_IDS);
  const seenIdsRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function handleValueChange(value) {
      const next = Array.isArray(value) ? value : [value];
      let seen = seenIdsRef.current;
      if (seen === null) {
        seen = new Set(DEFAULT_OPEN_IDS);
        seenIdsRef.current = seen;
      }
      for (const id of next) {
        if (!seen.has(id)) {
          onEvent("support_mainnet_faq_opened", {
            id
          });
          seen.add(id);
        }
      }
      setOpenIds(next);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleValueChange = t0;
  let t1;
  if ($[1] !== t || $[2] !== tCommon) {
    t1 = FAQ_ITEMS.map(f => {
      const question = t(`items.${f.id}.question`);
      const answer = t(`items.${f.id}.answer`);
      return {
        id: f.id,
        question: <span className="text-body-lg font-semibold text-foreground-primary">{question}</span>,
        answer: <div className="flex max-w-prose flex-col gap-3"><p className="text-body leading-relaxed text-foreground-secondary">{parseInlineBold(answer)}</p>{f.docsPath !== undefined ? <InfoModal.DocsLink href={`${DOCS_URL}${f.docsPath}`} label={tCommon("read_docs")} /> : null}</div>,
        triggerClassName: "py-5 lg:py-6",
        contentClassName: "pb-6 lg:pb-7"
      };
    });
    $[1] = t;
    $[2] = tCommon;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const items = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("space-y-10", APP_HEADER_SCROLL_MARGIN_CLASS);
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("eyebrow");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("lead");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <SectionHeading eyebrow={t3} title={t4} lead={t5} headingId="faqs-heading" centered={true} />;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("mx-auto w-full", READING_COLUMN_CLASS);
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== items || $[17] !== openIds) {
    t8 = <div className={t7}><AppAccordion type="multiple" items={items} value={openIds} onValueChange={handleValueChange} /></div>;
    $[16] = items;
    $[17] = openIds;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <section id="faqs" aria-labelledby="faqs-heading" className={t2}>{t6}{t8}</section>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}